<ion-header role="none" class="map-header">
  <!--///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        MAIN HEADER
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////-->
    <div class="container-lg">
        <ion-toolbar>

            <ion-buttons slot="start">
                <ion-button (click)="dismiss()" attr.aria-label="{{ 'ARIA_LABEL_BACK' | translate }}">
                    <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
                </ion-button>
            </ion-buttons>

            <h5 class="ion-text-center">{{ 'BROWSER_GEOCODER_PROMPT' | translate }}&nbsp;{{ stop.label }}</h5>

            <ion-buttons slot="end">
                <ion-button (click)="onClickHelp()" attr.aria-label="{{ 'ARIA_LABEL_HELP' | translate }}">
                    <ion-icon slot="icon-only" name="help-circle-outline"></ion-icon>
                </ion-button>
            </ion-buttons>

        </ion-toolbar>

        <!--///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            HEADER SEARCHBAR
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////-->

        <ion-toolbar>
            <app-address-search *ngIf="searchType === 'search'" [mapLoaded]="mapLoaded" (addressSearchEvent)="onAddressSearchEvent($event)"></app-address-search>
            <ion-button *ngIf="searchType === 'map'" expand="full" color="emphasized" [innerHTML]="'MAP_MAP_SEARCH_INSTRUCTIONS' | translate"></ion-button>
        </ion-toolbar>
    </div>
</ion-header>

<!--///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    CONTENT
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////-->

<ion-content>

    <div *ngIf="searchType === 'map'" class="map-overlay map-search-loc-container">
        <div class="prompt-container">
            <div class="prompt-label" [innerHTML]="'MAP_MAP_SEARCH_PROMPT' | translate"></div>
            <div *ngIf="zoomedInEnough && location.name" class="loc-label">{{ location.name }}</div>
            <div *ngIf="zoomedInEnough && !invalidMapSearch && !location.name">&nbsp;</div>
            <div *ngIf="zoomedInEnough && invalidMapSearch" [innerHTML]="'MAP_MAP_SEARCH_NO_LOC' | translate"></div>
            <div *ngIf="!zoomedInEnough" [innerHTML]="'MAP_MAP_SEARCH_ZOOM' | translate"></div>
            <div class="ion-text-center">
                <ion-button
                    size="small"
                    class="emphasized-button"
                    *ngIf="zoomedInEnough && !invalidMapSearch"
                    (click)="next()"
                    [innerHTML]="'MAP_MAP_SEARCH_BUTTON_NEXT' | translate"></ion-button>
            </div>
        </div>
    </div>

    <div *ngIf="searchType === 'map'" class="center-marker center-marker-generic"></div>

    <div #map id="map" class="container-lg">
        <!-- <page-map-type *ngIf="mapLoaded"></page-map-type> -->
        <div class="map-spinner" *ngIf="!mapLoaded">
            <ion-spinner></ion-spinner>
        </div>
        <ion-button *ngIf="mapLoaded" color="emphasized" class="button-map-search" (click)="toggleSearchType()">
            <ion-icon slot="start" *ngIf="searchType === 'search'" name="square-outline"></ion-icon>
            <ion-icon slot="start" *ngIf="searchType === 'map'" name="checkbox-outline"></ion-icon>
            <ion-label>{{ 'MAP_MAP_SEARCH_BUTTON_USE_MAP' | translate }}</ion-label>
        </ion-button>
    </div>

    <div #placesMap id="places-map" tabindex="-1" aria-hidden="true"></div>

    <div *ngIf="searchType === 'search'" class="hide-for-small-screen">
        <ion-button
            class="map-search-submit-button"
            [disabled]="nextDisabled"
            (click)="next()"
            [innerHTML]="'BUTTON_NEXT' | translate"></ion-button>
    </div>

</ion-content>

<!--///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    FOOTER
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////-->

<ion-footer class="map-footer hide-for-large-screen">
    <ion-button
        id="nextButton"
        expand="block"
        class="emphasized-button"
        (click)="next()"
        [disabled]="nextDisabled"
        [innerHTML]="'BUTTON_NEXT' | translate"></ion-button>
</ion-footer>